import { useQuery } from '@tanstack/react-query';
import fetchData from 'utils/fetchData';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

export function useApplicationQuery(
  enabled = false,
  refetchInterval: number | false = false,
) {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<ClientApplication>({
    queryKey: ['client', 'application'],
    queryFn: async () => {
      try {
        const resp = await fetchData('/client/application', {
          headers: {
            'Content-Type': 'application/vnd.4finance.web.v1.hal+json',
            Accept: 'application/vnd.4finance.web.v1.hal+json',
          },
        });

        return resp;
      } catch (e) {
        error('[useApplicationQuery][GET /client/application]', e);
        showError();
        throw e;
      }
    },
    enabled,
    refetchInterval,
  });
}

export type ClientApplication = {
  confirmed: boolean;
  id: string;
  status: string;
  amount: number;
  term: number;
  resolution: string;
  resolutionDetail: string;
  resolutionMessage: string;
  expired: boolean;
  proposal: {
    type: string;
    amount: number;
    term: number;
    expiryDate: string;
  };
};
